import {getApiBase} from '../../env';

export const fullUrl = (url: string) => `${getApiBase()}${url}`

export function fileExt(name:string) {
    const m = name.match(/\.([^.]+)$/)
    return m && m[1]
}
